import * as Sentry from '@sentry/vue'
import { type App as VueApp } from 'vue'
import router from '../router'

// Using MongoDB database with abstraction layer

export const setupSentry = (app: VueApp) => {
  if(import.meta.env.MODE.toString().toLowerCase().trim() !== 'production') return
  Sentry.init({
    app,
    dsn: 'https://a8c85d8025b35ad88b27d86d0d5030dd@o176457.ingest.us.sentry.io/4511387624407040',
    environment: import.meta.env.MODE ?? 'development',
    integrations: [
      Sentry.vueIntegration({ app, tracingOptions: { trackComponents: false } }),
      Sentry.browserTracingIntegration({
        router,
        enableInp: true,
        shouldCreateSpanForRequest: (url: string) => {
          return (
            url.includes('leadconnectorhq.com') || url.includes('msgsndr.com') || url.includes('msgsndr.net')
          )
        },
      }),
      Sentry.browserProfilingIntegration(),
      Sentry.moduleMetadataIntegration(),
    ],
    allowUrls: [
      /https?:\/\/([a-z0-9-]+\.)*leadconnectorhq\.com\/hltestmanager(?:\/|$|\?)/,
      /https?:\/\/([a-z0-9-]+\.)*msgsndr\.net/,
    ],
    sampleRate: 0.1, // error sample rate
    tracesSampleRate: 0.1, // span/performance sample rate,keep bare minimum
    tracePropagationTargets: [/https?:\/\/(.*)?leadconnectorhq\.com/],
    sendDefaultPii: true, // Set to true to continue receiving user IP addresses
  });

  Sentry.setTag('app', 'kaizen-frontend');
}